"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
var TokenizedField = function (props) {
    var classes = classNames('adyen-field', {
        'adyen-field--focused': props.hasFocus,
        'adyen-field--error': props.hasError,
    });
    return (React.createElement("div", { className: classes, "data-cse": props.fieldName }));
};
exports.default = TokenizedField;
//# sourceMappingURL=tokenized_field.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/credit_cards/tokenized_field.js
// module id = ivrC
// module chunks = 20 21 22